import { isExpiredToken } from '@/utils/cognito';
import url from '@/utils/config';
import axios from 'axios';
import { ApiUrlMobile } from './constants';

const baseURL = ApiUrlMobile.DOMAIN;

/**
 * NUROモバイルマイページBFFを呼出す
 * nuromobile-mypage-api
 */
const instance = axios.create({
  baseURL,
});

instance.interceptors.request.use((config) => {
  if (config.headers) {
    // eslint-disable-next-line no-param-reassign
    config.headers['content-type'] = 'application/json';
  } else {
    // eslint-disable-next-line no-param-reassign
    config.headers = { 'content-type': 'application/json' };
  }

  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // ログイントークンの有効期限が切れていたら、ログイン画面に遷移
    if (isExpiredToken(error)) {
      sessionStorage.clear();
      window.location.href = url('/login');
      return;
    }

    throw error;
  }
);

export default instance;
